import { Dispatch, SetStateAction } from 'react';

export function makeRequest<T>(
  method: 'POST' | 'GET' | 'PATCH' | 'DELETE',
  url: string,
  body: object | undefined,
  setLoading: Dispatch<SetStateAction<boolean>>,
  onSuccess: (value: T) => void,
  onFinish?: () => void
) {
  setLoading(true);
  fetch('/api' + url, {
    body: (body !== undefined && JSON.stringify(body)) || undefined,
    credentials: 'same-origin',
    method,
  })
    .then((response) => {
      if (!response.ok) {
        if (response.status === 401) {
          window.location.replace('/develop');
        }
        throw new Error(response.status.toString());
      }
      if (response.status !== 204) {
        return response.json();
      }
    })
    .then(onSuccess)
    .finally(() => {
      if (onFinish !== undefined) {
        onFinish();
      }
      setLoading(false);
    });
}
